import React from "react";
import { useMyLearning } from "lib/components/MyLearning/context";
import BaseGrid from "Components/Fragment/BaseGrid";
import EmptyFilterResult from "./Filter/components/EmptyFilterResult";

import AccordionCourses from "./AccordionCourses";
import AccordionProgram from "./AccordionProgram";

const MainContent = ({
  isManagerOrAdmin,
  onProgramClick,
  openDetails,
  closeDetails,
  languageContext,
}) => {
  const { isBt, filteredCourses, searching, filteredPrograms } =
    useMyLearning();

  if (
    !filteredCourses?.active?.length &&
    !filteredPrograms?.active?.length &&
    !searching
  ) {
    return <EmptyFilterResult label={languageContext("infNoSearchResult")} />;
  }

  return (
    <BaseGrid
      childWidth="auto"
      justifyContent={"space-between"}
      direction="column"
    >
      <AccordionProgram
        isManagerOrAdmin={isManagerOrAdmin}
        onProgramClick={onProgramClick}
        languageContext={languageContext}
      />
      {!isBt && filteredCourses?.active?.length > 0 && (
        <AccordionCourses
          isManagerOrAdmin={isManagerOrAdmin}
          openDetails={openDetails}
          closeDetails={closeDetails}
          languageContext={languageContext}
        />
      )}
    </BaseGrid>
  );
};

export default MainContent;
